import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/ChristopherMorford_Renters/subs.vtt';
import poster from '@/static/assets/reviews/ChristopherMorford_Renters/video.jpg';

export const ChristopherMorford: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Christopher',
  videoUrl: `${ASSETS_URL}/renters/ChristopherMorford_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
